module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 1